/**
 * TopBar — EINZIGE Kopfleiste der Plattform-Shell (Design-Korrektur:
 * die Personal-Vorlage hatte testweise zwei Kopfzeilen übereinander,
 * das ist ein Fehler und wird NICHT übernommen). Diese dunkle Leiste trägt
 * alles: links Sidebar-Collapse-Burger + Wortmarke, rechts Suche (⌘K),
 * AppSwitcher, EnvBadge, Benutzername, Abmelden.
 */
import { LogOut, Menu } from "lucide-react"
import { AppSwitcher } from "@/components/AppSwitcher"
import { EnvBadge } from "@/components/EnvBadge"
import { useAuth } from "@/auth/AuthProvider"

interface TopBarProps {
  onOpenPalette?: () => void
  onToggleSidebar?: () => void
}

export function TopBar({ onOpenPalette, onToggleSidebar }: TopBarProps) {
  const { user, signOut } = useAuth()
  const roles = user?.roles ?? []

  return (
    <div className="flex h-14 shrink-0 flex-nowrap items-center gap-3 bg-slate-900 px-4 text-white">
      <button
        type="button"
        onClick={onToggleSidebar}
        aria-label="Sidebar umschalten"
        className="shrink-0 rounded-md p-2 text-slate-300 hover:bg-slate-800 hover:text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-sky-400"
      >
        <Menu className="h-5 w-5" />
      </button>

      <a href="/dashboard" className="shrink-0 whitespace-nowrap text-sm font-semibold">
        RM<span style={{ color: "#e67e22" }}>NC</span> Technik
      </a>

      <div className="flex flex-1 items-center justify-end gap-2">
        <EnvBadge />

        <button
          type="button"
          onClick={onOpenPalette}
          aria-label="Suchen oder navigieren"
          className="hidden shrink-0 items-center gap-2 whitespace-nowrap rounded-md border border-slate-700 bg-slate-800/60 px-3 py-1.5 text-sm text-slate-300 transition-colors hover:bg-slate-800 hover:text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-sky-400 md:flex"
        >
          <span>Suchen…</span>
          <kbd className="ml-1 rounded bg-slate-700 px-1.5 py-0.5 text-[10px] font-medium">⌘K</kbd>
        </button>
        <button
          type="button"
          onClick={onOpenPalette}
          aria-label="Suchen oder navigieren"
          className="shrink-0 rounded-md p-2 text-slate-300 hover:bg-slate-800 hover:text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-sky-400 md:hidden"
        >
          <SearchIcon />
        </button>

        <AppSwitcher currentAppKey="technik" roles={roles} />

        <span className="hidden min-w-0 max-w-[10rem] truncate text-sm text-slate-300 md:inline">
          {user?.name ?? "Nicht angemeldet"}
        </span>

        <button
          type="button"
          onClick={signOut}
          aria-label="Abmelden"
          className="flex shrink-0 items-center gap-1.5 whitespace-nowrap rounded-md p-2 text-slate-300 hover:bg-slate-800 hover:text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-sky-400"
        >
          <LogOut className="h-4 w-4" />
          <span className="hidden text-sm md:inline">Abmelden</span>
        </button>
      </div>
    </div>
  )
}

function SearchIcon() {
  return (
    <svg
      viewBox="0 0 24 24"
      width="20"
      height="20"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.7}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <circle cx="11" cy="11" r="7" />
      <path d="m20 20-3.5-3.5" />
    </svg>
  )
}
